import { gql } from '@apollo/client';

const GET_DISTRIBUTION_CLASS = gql`
  query GetDistributionClass($irrigationChannelNetworkId: Int!) {
    siraDistributionClass(irrigationChannelNetworkId: $irrigationChannelNetworkId) {
      id
      title
      irrigationChannelNetworkId
      source
      canals {
        id
        name
        shares
        distributionSum
        inletDevice {
          id
          profile {
            id
            name
            source
          }
          metrics {
            flow {
              lastData
            }
            level {
              lastData
            }
          }
        }
      }
    }
  }
`;

export default GET_DISTRIBUTION_CLASS;
